// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2_F6T","title":"Header_title__32par","left":"Header_left__2BjxZ","clinicName":"Header_clinicName__2nVN0"};